export const IDPrefix = '#';  // Prefix for entity IDs
